// extracted by mini-css-extract-plugin
export default {"required":"RequiredLabel_required__wCUg3"};